<template>
  <v-container>
    <v-row>
      <v-col lg="6">
        <h1 class="title font-weight-light mb-2 black--text">
          <v-icon left color="black">mdi-format-list-bulleted</v-icon>
          <span id="widgetNameEdit">{{ $t("URUNLER.CATEGORIES.LIST_CATEGORY_TITLE") }}</span>
          <v-divider class="mt-2"></v-divider>
        </h1>
        <p class="text-caption grey--text text--darken-2 mb-2">
          {{ $t("URUNLER.CATEGORIES.LIST_CATEGORY_SUB_TITLE") }}
        </p>

        <v-row v-if="catsStatus">
          <v-col>
            <v-skeleton-loader class="mb-3 elevation-1" type="list-item"></v-skeleton-loader>
            <v-skeleton-loader class="mb-3 elevation-1" type="list-item"></v-skeleton-loader>
            <v-skeleton-loader class="mb-3 elevation-1" type="list-item"></v-skeleton-loader>
            <v-skeleton-loader class="mb-3 elevation-1" type="list-item"></v-skeleton-loader>
            <v-skeleton-loader class="mb-3 elevation-1" type="list-item"></v-skeleton-loader>
          </v-col>
        </v-row>

        <v-row v-if="kategoriListesi.length === 0">
          <v-col lg="12" class="py-0">
            <div class="widget-list-drag-drop-empty">
              <v-list class="widget-list-empty">
                <v-list-item class="widget-list-empty-item">
                  <v-list-item-content>
                    <v-list-item-title class="widget-list-empty-title text-center text-body-2 font-weight-medium">
                      <div>{{ $t("URUNLER.CATEGORIES.NOT_CETEGORIES_ADDITIONAL") }}</div>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="kategoriListesi.length > 0">
          <v-col cols="12">
            <div :key="key" v-for="(group, key) in hiyerarsikKategoriler">
              <v-card :style="{ 'margin-left': kat.depth * 15 + 'px' }" :key="kat.code" v-for="(kat) in group" class="mb-3">
                <div class="d-flex align-center mx-0 font-weight-light text-body-2 px-3 py-2">
                  <v-icon v-if="kat.parent === 0" small left>mdi-arrow-right</v-icon>
                  <v-icon v-else small left>mdi-subdirectory-arrow-right</v-icon>
                  {{ kat.name }}
                  <span v-show="kat.parent === 0" class="mx-2 grey--text text--darken-6 text-caption">({{ $t("URUNLER.CATEGORIES.MAIN_CATEGORY_TEXT") }})</span>
                  <v-spacer></v-spacer>
                  <div cols="12" lg="2" class="d-flex justify-end">
                    <v-tooltip bottom color="blue white--text">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          fab
                          x-small
                          color="blue lighten-5"
                          class="elevation-0 mr-2"
                          @click="kategoriDuzenle(kat.code)"
                          :loading="kategoriDuzenleLoading[kat.code]"
                        >
                          <v-icon small color="blue">mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("URUNLER.CATEGORIES.EDIT_CATEGORY_BTN") }}</span>
                    </v-tooltip>
                    <v-tooltip bottom color="red white--text">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          fab
                          x-small
                          color="red lighten-5"
                          class="elevation-0"
                          @click="kategoriKaldirDialog(kat.code)"
                          :loading="kategoriKaldirLoading[kat.code]"
                        >
                          <v-icon small color="red">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("URUNLER.CATEGORIES.DELETE_CATEGORY_BTN") }}</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="6">
        <div class="d-flex align-center py-0 px-0">
          <h1 v-if="!duzenlenenKategori" class="title font-weight-light black--text">
            <v-icon left color="black">mdi-playlist-plus</v-icon>
            {{ $t("URUNLER.CATEGORIES.ADD_CATEGORY_TITLE") }}
          </h1>
          <h1 v-else class="title font-weight-light black--text">
            <v-icon left color="black">mdi-refresh</v-icon>
            {{ $t("URUNLER.CATEGORIES.EDITING_CATEGORY_TITLE") }}
          </h1>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon v-bind="attrs" v-on="on">
                <v-icon dense color="blue darken-2">mdi-autorenew</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("URUNLER.CATEGORIES.RENEW_CATEGORY_LIST") }}</span>
          </v-tooltip>
        </div>
        <v-divider class="mb-2 mt-2"></v-divider>
        <p v-if="!duzenlenenKategori" class="text-caption grey--text text--darken-2 mb-2">
          {{ $t("URUNLER.CATEGORIES.ADD_CATEGORY_SUB_TITLE") }}
        </p>
        <p v-else class="text-caption grey--text text--darken-2 mb-2">
          {{ $t("URUNLER.CATEGORIES.EDITING_CATEGORY_SUB_TITLE") }}:
          <b>{{ duzenlenenKategoriName }}</b>
        </p>

        <v-row>
          <v-col cols="12" lg="12">
            <v-text-field
              prepend-inner-icon="mdi-chevron-right"
              class="mb-3 font-weight-light"
              :label="$t('URUNLER.CATEGORIES.ADD_CATEGORY_CAREGORY_NAME_LABEL')"
              hide-details
              solo
              v-model="kategoriData.kategoriAdi"
            ></v-text-field>
            <v-text-field
              prepend-inner-icon="mdi-chevron-right"
              class="font-weight-light"
              :label="$t('URUNLER.CATEGORIES.ADD_CATEGORY_CATEGORY_DESC_LABEL')"
              :hint="$t('URUNLER.CATEGORIES.ADD_CATEGORY_CATEGORY_DESC_HINT')"
              persistent-hint
              solo
              v-model="kategoriData.kategoriAciklamasi"
            ></v-text-field>
            <v-select
              prepend-inner-icon="mdi-chevron-right"
              :hint="$t('URUNLER.CATEGORIES.ADD_CATEGORY_PARENT_CATEGORY_LABEL')"
              persistent-hint
              :items="selectUrunKategorileri()"
              item-text="name"
              item-value="code"
              class="font-weight-light"
              solo
              :label="$t('URUNLER.CATEGORIES.ADD_CATEGORY_PARENT_CATEGORY_LABEL')"
              v-model="kategoriData.kategoriEbeveyni"
              clearable
            ></v-select>
            <div v-if="!duzenlenenKategori" class="d-flex justify-end">
              <v-btn outlined color="blue" dark @click="kategoriEkle" :loading="kategoriEkleDuzenleLoading">
                <v-icon left>mdi-plus-circle</v-icon>
                {{ $t("URUNLER.CATEGORIES.ADD_CATEGORY_BTN") }}
              </v-btn>
            </div>
            <div v-else class="d-flex justify-end">
              <v-btn outlined color="red darken-2" class="mr-3" dark @click="kategoriEkleForm">
                {{ $t("URUNLER.CATEGORIES.ADD_CATEGORY_CANCEL_BTN") }}
              </v-btn>
              <v-btn outlined color="green" dark @click="kategoriGuncelle" :loading="kategoriEkleDuzenleLoading">
                <v-icon left>mdi-refresh</v-icon>
                {{ $t("URUNLER.CATEGORIES.EDIT_CATEGORY_OK_BTN") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="catsStatus" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <div class="py-2 text-center">{{ $t("URUNLER.CATEGORIES.LOADING_CATEGORIES") }}</div>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog max-width="500" v-model="kategoriKaldirDialogStatus">
      <v-card>
        <v-card-title class="red--text text--darken-2">
          <span class="mr-2">{{ $t("URUNLER.CATEGORIES_DIALOG.WARN_TEXT") }}</span>
          <v-divider></v-divider>
        </v-card-title>
        <v-card-text class="text-body-2">{{ $t("URUNLER.CATEGORIES_DIALOG.WARN_INFO_CONTENT") }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-2" text @click="kategoriKaldirDialogStatus = false">
            {{ $t("URUNLER.CATEGORIES_DIALOG.CANCEL_BTN") }}
          </v-btn>
          <v-btn color="green" text @click="kategoriKaldir">
            <v-icon left>mdi-check</v-icon>
            {{ $t("URUNLER.CATEGORIES_DIALOG.DELETE_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import UrunlerService from "@/services/UrunlerService";
import { mapGetters, mapState } from "vuex";
import _ from "lodash";

export default {
  name: "UrunCategories",
  props: {
    state: {}
  },
  data() {
    return {
      kategoriData: {
        kategoriAdi: "",
        kategoriAciklamasi: "",
        kategoriEbeveyni: 0
      },
      duzenlenenKategori: false,
      kategoriKaldirDialogStatus: false,
      silinecekKategori: "",
      catsStatus: true,
      hiyerarsikKategoriler: [],
      kategoriDuzenleLoading: [],
      kategoriKaldirLoading: [],
      kategoriEkleDuzenleLoading: false
    };
  },
  computed: {
    ...mapState({
      kategoriListesi: state => state.Urunler.UrunCategories.kategoriListesi
    }),
    ...mapGetters({
      kategorilerGrouped: "Urunler/UrunCategories/kategorilerGrouped"
    }),
    duzenlenenKategoriName() {
      return _.find(this.kategoriListesi, {
        code: this.duzenlenenKategori
      }).name;
    }
  },
  methods: {
    selectUrunKategorileri() {
      let sayfaListesiHrk = this.kategorilerGrouped(this.kategoriListesi),
        sayfaListesi = [];
      for (let group of sayfaListesiHrk) {
        for (let page of group) {
          page.name = this.depthLine(page.depth) + " " + page.name;
          sayfaListesi.push(page);
        }
      }

      if (this.duzenlenenKategori) {
        /**
         * Güncelleme verisindeki kategorinin alt sayfalarını seçilemeyecek
         * biçimde iptal et
         */
        let code = this.duzenlenenKategori,
          category = _.find(sayfaListesi, { code: code }),
          hierarchy = _.find(sayfaListesi, {
            hierarchy: category.hierarchy
          }),
          hierarchyCode = hierarchy.hierarchy;

        let sayfaGuncelleParent = _.filter(sayfaListesi, s => s.hierarchy === hierarchyCode),
          page = _.find(sayfaGuncelleParent, s => {
            return s.code === code;
          });

        let guncelSayfaListesi = sayfaListesi;
        _.remove(guncelSayfaListesi, s => {
          return (s.depth > page.depth && s.hierarchy === hierarchyCode) || s.code === code;
        });

        sayfaListesi = guncelSayfaListesi;
      }
      return sayfaListesi;
    },
    /**
     * Yeni kategori eklmesi yapar
     */
    kategoriEkle() {
      const { kategoriAdi, kategoriAciklamasi, kategoriEbeveyni } = this.kategoriData;
      this.kategoriEkleDuzenleLoading = true;
      this.$store
        .dispatch("Urunler/UrunCategories/kategoriEkle", {
          kategoriAdi,
          kategoriAciklamasi,
          kategoriEbeveyni
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.ADD_CATEGORY_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.kategoriEkleForm();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.kategoriEkleDuzenleLoading = false;
        });
    },
    /**
     * Herhangi bir kategoriyi düzenlemek için
     * ürün detayını getir ve kategori ekleme formu
     * üzerine işleme yap
     */
    kategoriDuzenle(kategoriCode) {
      this.kategoriDuzenleLoading[kategoriCode] = true;
      UrunlerService.kategoriDetay({ kategoriCode })
        .then(res => {
          if (res.status === 200) {
            this.kategoriData.kategoriAdi = res.data.name;
            this.kategoriData.kategoriAciklamasi = res.data.desc;
            this.kategoriData.kategoriEbeveyni = res.data.parent;
            this.duzenlenenKategori = kategoriCode;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.kategoriDuzenleLoading[kategoriCode] = false;
        });
    },
    kategoriGuncelle() {
      let kategoriCode = this.duzenlenenKategori;
      const { kategoriAdi, kategoriAciklamasi, kategoriEbeveyni } = this.kategoriData;
      this.kategoriEkleDuzenleLoading = true;
      this.$store
        .dispatch("Urunler/UrunCategories/kategoriGuncelle", {
          kategoriCode,
          kategoriAdi,
          kategoriAciklamasi,
          kategoriEbeveyni
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.UPDATE_CATEGORY_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.kategoriEkleForm();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.kategoriEkleDuzenleLoading = false;
        });
    },
    kategoriKaldir() {
      let kategoriCode = this.silinecekKategori;
      this.kategoriKaldirLoading[kategoriCode] = true;
      this.$store
        .dispatch("Urunler/UrunCategories/kategoriKaldir", { kategoriCode })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.DELETE_CATEGORY_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.kategoriEkleForm();
            this.silinecekKategori = "";
            this.kategoriKaldirDialogStatus = false;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.kategoriKaldirLoading[kategoriCode] = false;
        });
    },
    kategoriKaldirDialog(kategoriCode) {
      this.silinecekKategori = kategoriCode;
      this.kategoriKaldirDialogStatus = true;
    },
    kategoriEkleForm() {
      this.kategoriData.kategoriAdi = "";
      this.kategoriData.kategoriAciklamasi = "";
      this.kategoriData.kategoriEbeveyni = 0;
      this.duzenlenenKategori = false;
    },
    depthLine(length) {
      let lines = "";
      for (let i = 0; i < length; i++) {
        lines += "—";
      }
      return lines;
    },
    generateGroupedCategories(kategoriList) {
      let sayfaListesiHrk = this.kategorilerGrouped(kategoriList),
        sayfaListesi = [];

      for (let group of sayfaListesiHrk) {
        for (let page of group) {
          page.name = this.depthLine(page.depth) + " " + page.name;
          sayfaListesi.push(page);
        }
      }
      return sayfaListesi;
    }
  },
  created() {
    /**
     * Urun Kategorilerinin Listesini Getir
     */
    this.$store
      .dispatch("Urunler/UrunCategories/kategoriListesi")
      .then(res => {
        this.catsStatus = false;
        if (res.status === 200) {
          if (res.data.length > 0) {
            this.hiyerarsikKategoriler = this.kategorilerGrouped(res.data);
          }
        }
      })
      .then(() => {
        /**
         * Store değikliklerini dinle ve değişiklik durumunda kategorileri tekrar güncelle
         */
        this.$store.watch(
          state => state.Urunler.UrunCategories.kategoriListesi,
          newData => {
            this.hiyerarsikKategoriler = this.kategorilerGrouped(newData);
          }
        );
      });
  },
  watch: {
    "kategoriData.kategoriEbeveyni"(val) {
      this.kategoriData.kategoriEbeveyni = val ?? 0;
    }
  }
};
</script>

<style>
#widgetNameEdit {
  position: relative;
}

#widgetNameEdit span {
  padding-right: 30px;
}

#widgetNameEdit .edit-icon {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  pointer-events: none;
}

.widgets-icon {
  left: -10px;
  height: 10px;
  cursor: grab;
}

.widget-list-drag-drop-empty {
  position: relative;
  top: 7px;
}

.widget-list-empty {
  background: rgba(0, 136, 249, 0.09) !important;
  border: 1px dashed #0088f8 !important;
  position: relative;
  width: 100%;
}

.widget-list-empty-item {
  min-height: 40px;
}

.widget-list-empty-title {
  color: #005194;
}

.dropzone.trashzone {
  position: relative;
  padding: 6px 6px 0 6px;
  height: 60px;
}

@keyframes opacity {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

#trashZoneContainer {
  animation: 350ms opacity;
}

#trashZone {
  position: absolute;
}

#widgetTrashZone {
  position: relative;
}

#widgetTrashZone span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
